import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Action, Store } from '@ngrx/store';
import { PermanentlyHolidayDate } from 'app/core/models/permanently-holiday-date';
import { PermanentlyHolidayDateService } from 'app/core/services';
import { State } from 'app/core/store/states';
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { mergeMap } from 'rxjs/operators';

import * as PermanentHolidayActions from '../../store/actions/permanent-holiday.actions';


@Injectable()
export class PermanentHolidayEffects {

    constructor(
        private actions$: Actions,
        private store: Store<State>,
        private permanentlyHolidayDateService: PermanentlyHolidayDateService
    ) { }

    @Effect()
    GetAll$: Observable<Action> = this.actions$.pipe(
        ofType<PermanentHolidayActions.GetTop5>(PermanentHolidayActions.GET_TOP_5),
        mergeMap((action) => {
            return this.permanentlyHolidayDateService.takeTop5().map((permanentHolidays: PermanentlyHolidayDate[]) => {
                return new PermanentHolidayActions.GetTop5Success(permanentHolidays)
            }, _ => of(new PermanentHolidayActions.GetTop5Error()))
        })
    )
}
